import { Input, Directive } from '@angular/core';

@Directive()
export class BaseIcon {
	@Input() iconCls: string;
	@Input() style: string;
}
